import React, { useContext } from "react";
import { TreeItemsFromData } from "./CatalogItems";
import {
    SearchValueContext,
    TreeContext,
} from "../../../Store";

// Filterung der Daten wenn Suchfeld verwendet wird

export function SearchList({ items }) {
    const [SearchValue] = useContext(SearchValueContext);
    const tree = useContext(TreeContext);
    const TreeSelected = tree.selected;

    if (!SearchValue) {
        return <div><TreeItemsFromData items={items} /></div>;
    }

    const seenIds = new Set();
    const searchResult = [];
    const pa = [];

    const check = (i) => {
        for (let m = 0; m < i.length; m++) {
            const item = i[m];
            const nameLower = item.name?.toLowerCase() ?? '';
            if (nameLower.includes(SearchValue.toLowerCase()) || item.code?.includes(SearchValue)) {
                if (!seenIds.has(item.global_id)) {
                    seenIds.add(item.global_id);
                    searchResult.push(item);
                }
            }
            if (item.global_id === TreeSelected.parent_global_id &&
                item.objecttype_id === TreeSelected.parent_objecttype_id) {
                pa.push(item);
            }
            if (item.children_objecttypes?.length > 0) {
                check(item.children_objecttypes);
            }
        }
    };

    check(items);

    // Kinder aus den Treffern entfernen — sonst erscheint ein Kind doppelt,
    // wenn sowohl Eltern als auch Kind in den Suchergebnissen landen.
    const flatResults = searchResult.map(item => ({...item, children_objecttypes: []}));

    return (
        <div>
            <div>
                <TreeItemsFromData items={flatResults} pa={pa} />
            </div>
        </div>
    );
}
